import PropTypes from 'prop-types'
import React, { useEffect, useState } from "react"

import { connect } from "react-redux"
import { Link } from "react-router-dom"

import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import zithasLogoSmall from "../../assets/images/logos/smallLogo.png"
import zithasLogoFull from "../../assets/images/logos/zithas-logo.png"
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable"
//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"
import configure from 'configure'
import VideoSection from 'pages/Help/VideoSection'
import secureLocalStorage from 'react-secure-storage'

const Header = props => {
  const [search, setsearch] = useState(false)
  const [megaMenu, setmegaMenu] = useState(false)
  const [socialDrp, setsocialDrp] = useState(false)

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }

  }
  useEffect(() => {
    const body = document.body;

    body.classList.toggle("vertical-collpsed")
  }, []);
  const [helpVideo, setHelpVideo] = useState(false)

  const onClose = (isYes) => {
    if (isYes) {
      setHelpVideo(false)
    }
  }

  useEffect(() => {
    if (secureLocalStorage.getItem('tutorial') == 'skip') {
      setHelpVideo(false)
    } else {
      setHelpVideo(true)
    }
  }, [])

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header text-white" style={{ backgroundColor: "#330148" }}>
          <div className="d-flex">

            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to={`${configure.appUrl}`} className="logo logo-dark">
                <span className="logo-sm">
                  <img src={zithasLogoSmall} alt="" height="22" />
                </span>
              </Link>

              <Link to={`${configure.appUrl}`} className="logo logo-light">
                <span className="logo-sm">
                  <img src={zithasLogoFull} alt="" height="22" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-16 header-item text-white"
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search)
                }}
                type="button"
                className="btn header-item noti-icon text-white"
                id="page-header-search-dropdown"
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="dropdown  ms-1 text-white">
              <Link className="btn btn-sm px-3 d-flex align-items-center font-size-14 header-item text-white " onClick={() => setHelpVideo(true)} >
                <i className="dripicons-question pe-2 font-size-14 lh-0" style={{ lineHeight: 0 }} />
                <span>Help</span>
              </Link>
            </div>
            <div className="dropdown  ms-1 text-white">
              <Link className="btn btn-sm px-3 d-flex align-items-center font-size-14 header-item text-white " target='_blank' to={`${configure.appUrl}/calendar`} >
                <i className="bx bx-calendar-event pe-2 font-size-15" />
                <span>Calendar</span>
              </Link>
            </div>


            <ProfileMenu />

          </div>
        </div>

        <div className={`note-sticky-form ${helpVideo ? "d-block" : "d-none"}`}>
          <Draggable handle=".modal-header" cancel=".modal-body">
            <ResizableBox
              width={700}
              style={{
                position: "fixed",
                top: "10%",
                right: "15%",
                zIndex: "999",
                backgroundColor: "#fff",
                maxHeight: "fit-content",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div className="modal-header ">
                <h5 className="modal-title mt-0">Introducer Portal Walkthrough: A Complete User Guide</h5>
                <button
                  type="button"
                  onClick={() => {
                    setHelpVideo(false)
                  }}
                  className="btn-modal-close"
                >
                  <span aria-hidden="true" className="btn-modal-span">
                    &times;
                  </span>
                </button>
              </div>
              {/* <PunchLogs data={logs} /> */}
              <VideoSection onClose={onClose} />
            </ResizableBox>
          </Draggable>
        </div>

      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
}

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
